import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "../../service/api";
import { getStore } from "../../service/store/StoreService";

interface StoreSlice {
  storeID: number;
  selectedFormState: string;
  storeTypeList: { id: number, name: string }[];
  values: any;
  stores: any;
  total: number;
  loading: boolean;
  error: any;
  page: number;
  limit: number;
  totalPages: number;
  FoodAndBeverageID: string;
  status: string;
}

interface StoreTypeResponse {
  data: any[];
}

const initialState: StoreSlice = {
  storeID: 0,
  selectedFormState: "storeForm",
  storeTypeList: [],
  values: {},
  stores: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 0,
  loading: false,
  error: null,
  FoodAndBeverageID: "316",
  status: "",
};

export const fetchStoreType = createAsyncThunk(
  "storeType/fetchStoreType",
  async () => {
    const response = await ApiClient.get<StoreTypeResponse>("/category/main");
    return response.data.data;
  }
);
export const fetchStores = createAsyncThunk(
  "stores/fetchStores",
  async ({ page = 1, limit = 10 }: { page: number, limit: number }, { rejectWithValue }) => {
    try {
      const response = await getStore(page, limit);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
// eslint-disable-next-line @typescript-eslint/no-redeclare
const StoreSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setStoreID: (state, action: PayloadAction<number>) => {
      state.storeID = action.payload;
    },
    setSelectedFormState: (state, action: PayloadAction<string>) => {
      state.selectedFormState = action.payload;
    },
    setStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
    },

    setFormikValues: (state, action: PayloadAction<any>) => {
      state.values = { ...state.values, ...action.payload };
    },
    resetStoreValues: () => initialState,
    setPage: (state, action) => {
        state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStoreType.fulfilled,
      (state, action: any) => {
        state.storeTypeList = action.payload;
        state.FoodAndBeverageID = String(action.payload.find((item: any) => item.name === "F&B")?.id) || "316";
      }
    )
      //Fetch store list
      .addCase(fetchStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStores.fulfilled, (state, action) => {
        state.loading = false;
        state.stores = action.payload?.data||[];
        state.total = action.payload?.data?.total||0;
        // Keep page controlled by the UI (setPage) to avoid feedback loops
        // state.page = action.payload?.data?.page||1;
        state.limit = action.payload?.data?.limit||10;
        state.totalPages = action.payload?.data?.totalPages||0;
      })
      .addCase(fetchStores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setStoreID, setSelectedFormState, setFormikValues, resetStoreValues, setPage, setStatus, } = StoreSlice.actions;
export default StoreSlice.reducer;
